import { Box, Grid, Stack, useTheme } from "@mui/material";
import CaseStudyHero from "./caseStudyHero";
import CaseStudyOverviewLayout from "./caseStudyOverviewLayout";
import CaseStudyResults from "./caseStudyResults";
import CaseStudyBulletOnlyRegion from "./caseStudyBulletOnlyRegion";
import { useTranslation } from "react-i18next";
import CaseStudyProject from "./caseStudyProjects";
import CaseStudyCrossIndustries from "./caseStudyCrossIndustries";
import ButtonComponent from "../../components/form/buttonComponent";
import { useCallback, useState } from "react";
import GetQuote from "../contactUs/getQuote";
import companyData from '../../assets/data/company.json';

const CaseStudyDetails = ({
    data
}) => {
    const {t} = useTranslation();

    const [openQuoteForm, setOpenQuoteForm] = useState(false);

    const getAQuote = useCallback(() => {
        // setOpenQuoteForm(true);

        window.open(companyData.contact.formLinks.quotation, "_blank");
    }, []);

    return (
        <>
            <Box data-aos="fade-up">
                <CaseStudyHero 
                    title={t(data.title)}
                    industry={data.industry}
                    themeColor={data.themeColor}
                />

                <CaseStudyOverviewLayout data={data}/>

                <CaseStudyResults data={data.results}/>

                <Grid
                    className="sectionSpacing"
                    direction={{xs: 'column', md: 'row'}}
                    justifyContent='start'
                    alignItems='start'
                    container
                    spacing={{xs: 2, md: 10}}
                    px={{xs: 1, md: 0}}
                >
                    <Grid size={{xs: 12, md: 6}}>
                        <CaseStudyBulletOnlyRegion title={t('caseStudies.challenges')} data={data.challenges}/>
                    </Grid>

                    <Grid size={{xs: 12, md: 6}}>
                        <CaseStudyBulletOnlyRegion title={t('caseStudies.scalability')} data={data.scalability}/>
                    </Grid>
                </Grid>

                <CaseStudyProject industryKeyword={data.title}/>

                <CaseStudyCrossIndustries data={data.crossIndustry}/>

                <Stack
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    width='100%'
                    py={2}
                >
                    <ButtonComponent 
                        label={t('caseStudies.interested')}
                        onClick={getAQuote}
                        sx={{
                            animation: 'bounceButton 1s infinite'
                        }}
                    />
                </Stack>
            </Box>

            <GetQuote open={openQuoteForm} setOpen={setOpenQuoteForm}/>
        </>
    );
}

export default CaseStudyDetails;